import { render, staticRenderFns } from "./IndexPayroll.vue?vue&type=template&id=5cacc247"
import script from "./IndexPayroll.vue?vue&type=script&lang=js"
export * from "./IndexPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports